<div>
  <div *ngIf="CanShow === 1 ">
    <div class="row card-deck">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form">
        <div class="card-header wh-header" *ngIf="CurrentActorIdentitiesController">
          <div class="row">
            <div class="col-md-10 pink">
              <i class="fa fa-id-card"></i> My  Identifications
            </div>
            <div class="col-md-2 float-right" *ngIf="CanEdit === 1 ">
              <a (click)="openNewContent()" class="nav-link-hand btn btn-primary"><span class="badge badge-pink"> <i class="fa fa-plus"></i></span>Add New</a>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="card-block">
            <div *ngFor="let l of CurrentActorIdentitiesController">
              <div class="media mb-1">
                <div class="media-body">
                  <h4 class="font-medium-1 mt-1 mb-1">Expiration Date - {{l.ValidTo | date:'dd-MMM-yyyy'}}</h4>
                  <p class="text-muted font-small-3 pink">{{l.CredentialType}}, {{l.IssuingAuthorityLongValue}}</p>
                  <p class="text-muted font-small-2">{{l.CredentialNumber}}</p>
                </div>
                <div class="mt-1">
                  <div class="row">
                    <!--<div class="float-left">-->
                    <a (click)="OpenDetailContent(l.ActorCredentialCode)" class="nav-link-hand">
                      <span class="badge">
                        <i class="fa fa-list grey"></i>
                      </span>
                    </a>
                    <a (click)="openDocContent(l.ActorDocCode)" class="nav-link-hand">
                      <span class="badge">
                        <i class="fa fa-file grey"></i>
                      </span>
                    </a>
                    <a (click)="del_(l.ActorCredentialCode)" *ngIf="CanEdit === 1 " class="nav-link-hand">
                      <span class="badge">
                        <i class="fa fa-times grey"></i>
                      </span>
                    </a>
                    <!--</div>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <!--<div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form">

          <section id="paging" class="mb-3" *ngIf="CanShow === 1 ">

            <div class="row">
              <div class="col-12">
                <div *ngIf="CurrentActorIdentitiesController">
                  <div class="card">
                    <div class="card-header">
                      <div class="row  card-title">
                        <div class="col-md-10 ">
                          <i class="fa fa-id-card"></i>    Identifications
                        </div>
                        <div class="col-md-2 float-right" *ngIf="CanEdit === 1 ">
                          <a (click)="openNewContent()" class="nav-link-hand"><span class="badge badge-pink"> <i class="fa fa-plus"></i></span>Add New</a>
                        </div>
                      </div>
                    </div>
           
                  </div>
                </div>
              </div>
            </div>

          </section>
       

        </div>-->
      </div>
    </div>

  <div *ngIf="CanShowRegistryView === 1 && CurrentActorIdentitiesController && CurrentActorIdentitiesController.length >0 ">
    <div class="row card-deck">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form">
        <div class="row">
          <div class="col-12">
            <div *ngIf="CurrentActorIdentitiesController">
              <div class="card">
                <div class="card-header   wh-header">
                  <div class="row">
                    <div class="col-md-10 pink">
                      <i class="fa fa-id-card"></i>    Identifications
                    </div>

                  </div>
                </div>
                <div class="card-body">
                  <div class="card-block">
                    <div *ngFor="let l of CurrentActorIdentitiesController">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label>Expiration Date - {{l.ValidTo | date:'dd-MMM-yyyy'}}</label>
                            <p>{{l.CredentialType}}, {{l.IssuingAuthorityLongValue}}</p>
                            <p>{{l.CredentialNumber}}</p>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  </div>

